import { Icon } from '@vzmi/shp_shared_compo'
import { HyperLink } from '../../../../Common/Form'
import YPopover from '../../../../Common/Popover'
import styles from './index.css'

const NewProductBtn = props => {
  return (
    <HyperLink
      data-role='new-product-btn'
      {...props}
    >
      <Icon
        name='add-attachments'
        color='#5478fc'
        size={14}
        align='middle'
      />
      {' '}
      新增屬性商品
    </HyperLink>
  )
}

export const NewProductBtnWithPopup = props => {
  return (
    <YPopover content='非快速到貨賣場可直接新增屬性商品'>
      <div className={styles.popupContainer}>
        <NewProductBtn {...props} />
      </div>
    </YPopover>
  )
}

export default NewProductBtn
